/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { modifier } from 'ember-modifier';
import { registerDestructor } from '@ember/destroyable';

export default class TryAgainComponent extends Component {
  addClickOutsideListener = modifier(
    (element) => {
      this.clickListener = (e) => {
        if (e.target.id === 'chat-try-again-modal') {
          e.preventDefault();
          element.removeEventListener('click', this.clickListener, false);
          this.args.onClose();
        }
      };

      element.addEventListener('click', this.clickListener, false);
      registerDestructor(this, () => {
        element.removeEventListener('click', this.clickListener, false);
      });
    },
    { eager: false }
  );
}
